import { render, staticRenderFns } from "./CenterCenter2.vue?vue&type=template&id=57f5008d&scoped=true&"
import script from "./CenterCenter2.vue?vue&type=script&lang=js&"
export * from "./CenterCenter2.vue?vue&type=script&lang=js&"
import style0 from "./CenterCenter2.vue?vue&type=style&index=0&id=57f5008d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5008d",
  null
  
)

export default component.exports